import { handleMessages, load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('submit', '[data-pickup-empties-report-form]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');

  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serializeArray(),
  }).then(handleMessages).then((data) => {
    setTimeout(() => 1500);
    return data;
  });

  load($form, promise, {
    errorClass: 'error',
  });

  this.reset();
});
